<template>
  <NuxtLink :to="localePath(post.external_url)" class="card card--service image_wrapper" v-for="(post, i) in posts" :key="i">
    <div class="card__wrapper">
      <div class="card__group">
        <div class="card__number">
          ({{ (i + 1).toString().padStart(2, "0") }})
        </div>
        <div class="card__title" v-if="post.alternate_title"><span v-html="post.alternate_title"></span></div>
        <div class="card__title" v-else>{{ post.title }}</div>
      </div>
      <div class="card__detail">
        {{ post.body }}
      </div>
    </div>
    <div class="card__button">
      <i class="icon-arrow-button"></i>
    </div>
    <div class="card__image">
      <img :src="post.image" :alt="post.title" />
    </div>
  </NuxtLink>
</template>

<script setup>

const localePath = useLocalePath();
const { posts } = defineProps(['posts'])

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";
@each $lang in $languages {
  html[lang="#{$lang}"] {
    .card {
        &.card--service {
            .card__number,.card__detail {
                @include font-size("body", $lang);
                @include font-weight("medium", $lang);
                line-height: 1.2;
            }

            .card__title {   
                @include font-size("h3", $lang);
                @include font-weight("bold", $lang);
                line-height: normal;

                @include media-breakpoint-down(md) {
                  @include font-size("h4", $lang);
                }
            }
        }
    }
  }
}

.card {
    &.card--service {
        color: $black;
        position: relative;
        overflow: hidden;
        min-height: 440px;
        padding: 3rem 3rem 1.5rem 3rem;
        background-color: transparent;
        flex: 0 0 55%;

        &:not(:last-child) {
            border-right: 1px solid $gray-1;
        }

        @include media-breakpoint-down(lg) {
            padding: 1.5rem;
        }

        @include media-breakpoint-down(md) {
            flex: 0 0 100%;
            min-height: 0;

            &:not(:last-child) {
              border-right: 0;
              border-bottom: 1px solid $gray-1;
            }
        }


        @include media-breakpoint-down(sm) {
          padding: 1.5rem 1rem;
        }

        .card__wrapper {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            transform: translateY(0);
            padding-right: 6rem;
            z-index: 1;
            @include transition(.3s);

            @include media-breakpoint-down(sm) {
              padding-right: 5rem;
            }
        }

        .card__title {
            @include media-breakpoint-up(lg) {
              padding-bottom: 3rem;
            }
        }

        .card__detail {
            color: $white;
            opacity: 0;
            transform: translateY(20px);
            @include transition(.3s);

            @include media-breakpoint-down(md) {
              display: none;
            }
        }

        .card__image {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            overflow: hidden;
            opacity: 0;
            z-index: -1; 
            animation: fadeOut 1s forwards;
            @include transition(0.8s);

            @include media-breakpoint-down(md) {
              display: none;
            }

            img {
                position: absolute;
                height: 100%;
                top: 0;
                left: 0;
                object-fit: cover;
                object-position: center;
                transform: scale(1.2);
                aspect-ratio: 12 / 7;
                @include transition(1s);
            }

            &::after{
              position: absolute;
              content: " ";
              width: 100%;
              height: 100%;
              background: linear-gradient(180deg, rgba($black, 0.00) 0%, $black 100%);
            }

        }

        .card__button {
            position: absolute;
            right: 3%;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0;
            width: 108px;
            height: 108px;
            border-radius: 50%;
            background-color: $white;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1;
            @include transition(.5s);
            i {
                font-size: px-to-rem(28);
                color: $black;
                @include transition(.5s);
            }

            @include media-breakpoint-down(lg) {
              width: 90px;
              height: 90px;

              i {
                font-size: px-to-rem(24);
              }
            }

            @include media-breakpoint-down(md) {
              top: 1.5rem;
              bottom: 0;
              opacity: 1;
              transform: translateY(0);
              width: 60px;
              height: 60px;
                i {
                  font-size: px-to-rem(16);
                }
            }
        }

        @include hover {
            color: $white;

            .card__image {
                animation: fadeIn 1s forwards;
                opacity: 1;
                z-index: 0;
                @include transition(0.8s);

                img {
                    transform: scale(1); 
                    @include transition(1s);
                }
            }

            .card__wrapper {
                transform: translateY(20px);
                @include transition(.3s);
            }

            .card__button {
                opacity: 1;
            }

            .card__detail {
                opacity: 1;
                transform: translateY(-30px);
                @include transition(.3s);
            }

            @include media-breakpoint-down(md) {
                color: $black;

                .card__button {
                  i{
                    transform: translate(8px, -8px);
                    @include transition(.5s);
                  }
                }
            }
        }
    }
}

@keyframes fadeIn {
    0% {
        width:0; 
    }
    100% {
        width:100%; 
    }
}

@keyframes fadeOut {
    0% {
        width:100%; 
    }
    100% {
        width:0; 
    }
}

</style>